/* Знак живёт в одной строке тулбара, поэтому он компактный: две «строки»
   (слово и иконки) укладываются в высоту соседних контролов. */
.logo {
  display: inline-flex;
  flex-direction: column;
  align-items: stretch;
  gap: var(--sp-1);
  flex: 0 1 auto;
  min-width: 0;
  color: var(--brand);
  user-select: none;
}

/* Знак-ссылка: цвет и подчёркивание ссылок здесь не нужны — знак уже нарисован
   своим цветом, а подчёркивание разрезало бы ряд иконок под словом. */
.logoLink {
  color: var(--brand);
  text-decoration: none;
  cursor: pointer;
  border-radius: var(--radius);
}

.logoLink:hover .word {
  text-decoration: underline;
  text-underline-offset: 2px;
}

.logoLink:focus-visible {
  outline: none;
  box-shadow: var(--focus-ring);
}

/* Слово задаёт ширину знака: ряд иконок под ним растягивается ровно по нему. */
.word {
  font-family: var(--font-brand);
  font-size: var(--fs-xl);
  line-height: 1.05;
  letter-spacing: 0.005em;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

/* «Plan» — чернилами темы: слово перестало спорить с фоном в тёмных палитрах
   и оттеняет градиентный акцент рядом. */
.wordPlain {
  font-weight: 600;
  color: var(--text);
}

/* Bold и градиент — только на последнем слове: акцент на том, ради чего
   приложение. Градиент из пары бренд-токенов (см. tokens.css); color остаётся
   заливкой на случай движка без background-clip: text — там слово просто
   бирюзовое, как раньше. */
.wordAccent {
  font-weight: 700;
  color: var(--brand);
  background: linear-gradient(100deg, var(--brand) 10%, var(--brand-2) 90%);
  -webkit-background-clip: text;
  background-clip: text;
  -webkit-text-fill-color: transparent;
}

/* Иконки распределяются по ширине слова — так ряд читается как часть знака,
   а не как отдельная панель кнопок. */
.icons {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: var(--sp-2);
  padding: 0 1px;
}

.icon {
  flex: none;
  width: 15px;
  height: 15px;
}

/* Горизонтальный вариант (проп layout="bar"): слово слева, иконки справа, во
   всю ширину родителя. Слово и сами иконки не меняются — .icon и .word общие
   для обеих раскладок, здесь только их взаимное расположение. Нужен мобильной
   лого-полосе (см. MobileShellHeader): та сама — верхняя строка экрана, и
   вертикальный знак смотрелся бы в ней узкой колонкой на пустом фоне, а не
   полосой. justify-content: space-between и не переносящееся слово держат
   ровно одну строку на любой ширине от 320px — переноса тут нет и без
   flex-wrap: nowrap (это поведение flex по умолчанию), но nowrap прописан
   явно, чтобы требование было видно в самой раскладке, а не подразумевалось. */
.bar {
  flex-direction: row;
  flex-wrap: nowrap;
  align-items: center;
  justify-content: space-between;
  gap: var(--sp-4);
  flex: none;
  width: 100%;
}

/* В стопке слово — потолок ширины иконок под собой, поэтому у него overflow:
   hidden и ellipsis. В полосе ширину некому диктовать сверху вниз: она сама
   растягивается на весь экран, а обрезать «Plan Flights» раньше, чем это
   реально понадобится, незачем. */
.bar .word {
  flex: none;
  overflow: visible;
  text-overflow: clip;
}

.bar .icons {
  flex: none;
  justify-content: flex-end;
}

/* Горизонтальный вариант без растяжки (проп layout="inline"): та же
   раскладка «слово — иконки в ряд», что у .bar, но width не задан, поэтому
   знак встаёт по размеру своего содержимого. Нужен там, где знак — лишь
   часть более широкой строки, а не вся строка целиком (однострочная шапка
   гостя, см. MobileShellHeader) — там width: 100% забрал бы себе всё место,
   не оставив кнопке меню рядом ничего. justify-content у .icons здесь не
   переопределён: в контейнере, сжатом по содержимому, space-between (базовое
   значение из .icons) распределять уже нечего — свободного места нет. */
.inline {
  flex-direction: row;
  flex-wrap: nowrap;
  align-items: center;
  gap: var(--sp-3);
  flex: none;
}

.inline .word {
  flex: none;
  overflow: visible;
  text-overflow: clip;
  white-space: nowrap;
}

/* На узких экранах знак сдаётся первым там, где делит строку с контролами
   (десктопная стопка в Toolbar, попапы). В layout="bar" делить строку не с
   кем — он там один, — но уменьшен всё равно: в лого-полосе это подпись
   экрана, а не заголовок страницы, и крупный размер был бы избыточен. */
@media (max-width: 720px) {
  .word {
    font-size: var(--fs-lg);
  }

  .icon {
    width: 11px;
    height: 11px;
  }
}
